<div class="form-container service-form">
  <div #fcomNotification *ngIf="formStatus === FormStatus.COMPLETE || formStatus === FormStatus.ERROR">
    <fcom-notification
      aria-live="polite"
      class="pr-small-y pr-clear-t mr-clear block"
      [theme]="formStatus === FormStatus.ERROR ? NotificationTheme.ALERT : NotificationTheme.INFO"
      [iconName]="formStatus === FormStatus.ERROR ? SvgLibraryIcon.INFO : SvgLibraryIcon.CHECKMARK"
    >
      {{
        (formStatus === FormStatus.ERROR ? 'SERVICE_FORMS.serviceForms.error.title' : 'plus.profile.updateSuccess')
          | finLocalization
      }}
    </fcom-notification>
  </div>

  <cms-rich-text
    *ngIf="travelProfileDescription$ | async as article"
    [extraClasses]="article.subjectTaxonomyTags?.join(' ')"
    [content$]="travelProfileDescription$"
  >
  </cms-rich-text>

  <div *ngIf="formStatus === FormStatus.LOADING" class="relative loader pr-medium-t">
    <fcom-loader [loaderType]="LoaderTheme.INLINE"></fcom-loader>
  </div>
  <form [formGroup]="reactiveForm" (ngSubmit)="onSubmit()" [finFormErrorFocus]="reactiveForm" class="pr-medium-t">
    <ng-container *ngIf="formStatus !== FormStatus.LOADING">
      <div class="flex flex--row flex--wrap form-subgroup">
        <fin-form-input-select
          [parentForm]="reactiveForm"
          [controlName]="TravelProfileFormField.SEAT_PREF"
          [options]="seatPreferenceOptions"
          [translationPrefix]="'plus.profile.travelProfile.seatPreference'"
        ></fin-form-input-select>
        <fin-form-input-select
          [parentForm]="reactiveForm"
          [controlName]="TravelProfileFormField.MEAL_PREF"
          [options]="mealPreferenceOptions"
          [translationPrefix]="'plus.profile.travelProfile.mealPreference'"
        ></fin-form-input-select>
        <div class="relative">
          <fin-form-input-select
            [parentForm]="reactiveForm"
            [controlName]="TravelProfileFormField.HOUSEHOLD_SIZE"
            [options]="householdSizeOptions"
            [translationPrefix]="'plus.profile.travelProfile.householdSize'"
          ></fin-form-input-select>
          <button
            type="button"
            class="icon absolute tooltip-button"
            fcomPopover
            [options]="tooltipOptions"
            [content]="contentTooltip"
            [closeText]="'plus.profile.tooltip.close' | finLocalization"
            [ariaCloseText]="'plus.profile.tooltip.ariaClose' | finLocalization"
            [attr.aria-label]="'plus.profile.tooltip.heading' | finLocalization"
          >
            <fcom-icon aria-hidden="true" class="icon-medium" [name]="SvgLibraryIcon.HELP_BLOCK"></fcom-icon>
          </button>
        </div>
      </div>
      <div class="flex flex--row flex--wrap flex--column form-subgroup">
        <fin-form-array
          [parentForm]="reactiveForm"
          [controlName]="TravelProfileFormField.CHILDREN_BIRTH_YEARS"
          [formGroupConfig]="childrenBirthYearsFormGroupConfig"
          [translationPrefix]="'plus.profile.travelProfile.childrenBirthYears'"
          [maxGroups]="maxChildren"
          [displayLabels]="true"
          [isNestedArray]="true"
        >
          <ng-template let-parentBirthYear="parentFormGroup" let-index="index">
            <fin-form-input-select
              [parentForm]="parentBirthYear"
              [controlName]="'birthYear'"
              [options]="birthYears"
              [translationPrefix]="'plus.profile.travelProfile.selectBirthYear'"
              [id]="'child_' + index + '_birthYear'"
            ></fin-form-input-select>
          </ng-template>
        </fin-form-array>
      </div>
      <h3 class="nordic-blue-900-text font-body-1">
        {{ 'plus.profile.travelProfile.topicsOfInterest.heading' | finLocalization }}
      </h3>
      <div class="form-subgroup">
        <fieldset>
          <legend class="is-vishidden">
            {{ 'plus.profile.travelProfile.topicsOfInterest.heading' | finLocalization }}
          </legend>
          <fin-form-input-checkbox-list
            [parentForm]="reactiveForm"
            class="flex--basis-full"
            [controlName]="TravelProfileFormField.TOPICS_OF_INTEREST"
            [checkboxList]="topicsOfInterestControls"
          ></fin-form-input-checkbox-list>
        </fieldset>
      </div>
    </ng-container>
    <div class="ps-small-t mr-xxsmall-r align-right">
      <fcom-button
        [type]="ButtonType.SUBMIT"
        [text]="'SERVICE_FORMS.serviceForms.save' | finLocalization"
      ></fcom-button>
    </div>
  </form>
</div>

<ng-template #contentTooltip>
  <h2 class="font-body-1 bold-type nordic-blue-900-text">
    {{ 'SERVICE_FORMS.serviceForms.fields.email.tooltip.heading' | finLocalization }}
  </h2>
  <p class="pr-xxsmall-t">{{ 'plus.profile.travelProfile.childrenTooltipText' | finLocalization }}</p>
  <p></p
></ng-template>
